import SingleQuestionnaireContainer from "./SingleQuestionnaireContainer";

export default SingleQuestionnaireContainer;
